import metadataConfig from '../config/metadata';

const locales = {
  se: 'sv_SE',
  fi: 'fi_FI',
  dk: 'da_DK',
  no: 'nb_NO',
};

const appleApps = {
  se: '794930992',
  fi: '794930992',
  dk: '794930992',
  no: '794930992',
};

export function getDefaultMetaData(country) {
  const defaultMeta = metadataConfig[country];

  const meta = {
    defaultTitle: defaultMeta.defaultTitle,
    titleTemplate: defaultMeta.titleTemplate,
    meta: [{
      name: 'og:title',
      content: defaultMeta.defaultTitle,
    }, {
      name: 'og:locale',
      content: locales[country],
    }, {
      name: 'og:site_name',
      content: defaultMeta.siteName,
    }, {
      name: 'og:type',
      content: 'website',
    }],
  };

  if (appleApps[country]) {
    meta.meta.push({
      name: 'apple-itunes-app',
      content: `app-id=${appleApps[country]}`,
    });
  }

  if (defaultMeta.description) {
    meta.meta = meta.meta.concat([{
      name: 'description',
      content: defaultMeta.description,
    }, {
      name: 'og:description',
      content: defaultMeta.description,
    }]);
  }

  return meta;
}



// WEBPACK FOOTER //
// ./src/util/metaDataBuilder.js